<template>

    <div class="GuideMeals col-12" :class="divClasses">
        <b>Meals:</b><br>
        <div v-if="typeOfMeal==='TwoWhatever'">
            1 big whatever you want meal an hour after waking up<hr style="width: 50%">1 whatever you want meal 5 hours after the first meal
        </div>
        <div v-if="typeOfMeal==='OneAndOne'">
            1 big healthy 
            <router-link class="link" to="/Health/Recipes/WholeMeals/Breakfast">breakfast starch meal</router-link>
            an hour after waking up<hr style="width: 50%">1 whatever you want meal 5 hours after the first meal
        </div>
        <div v-if="typeOfMeal==='TwoStarch'">
            1 big healthy breakfast starch meal an hour after waking up<hr style="width: 50%">1 healthy
            <router-link class="link" to="/Health/Recipes/WholeMeals/Lunch">lunch starch meal</router-link> 5 hours after the first meal
        </div>
        <div v-if="typeOfMeal==='Fast'">No meals today</div>
    </div>

</template>
<script>

export default {
    name: 'GuideMeals',
    props: {
        typeOfMeal: String,
        divClasses: String
    }
};
</script>